import Vue from 'vue'

const luConcern = {
  state: {
    luConcerns: [],
    selectedLuConcern: {},
    saving: false,
    searchCount: 0,
  },

  getters: {
    luConcerns(state) {
      return state.luConcerns
    },
    selectedLuConcern(state) {
      return state.selectedLuConcern
    },
    loading(state) {
      return state.searchCount > 0
    },
  },

  mutations: {
    luConcerns(state, payload) {
      state.luConcerns = payload
    },
    selectedLuConcern(state, payload) {
      state.selectedLuConcern = JSON.parse(JSON.stringify(payload))
    },
    saving(state, payload) {
      state.saving = payload
    },
    searchCount(state, payload) {
      state.searchCount = payload
    },
    increaseSearchCount(state, payload) {
      state.searchCount = state.searchCount + 1
    },
    decreaseSearchCount(state, payload) {
      state.searchCount = state.searchCount - 1
    },
  },

  actions: {
    setSelectedLuConcern(context, payload) {
      context.commit('selectedLuConcern', payload)
    },
    loadLuConcerns(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'LuConcern'
        context.commit('increaseSearchCount')
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('luConcerns', res.data)
            context.commit('decreaseSearchCount')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('decreaseSearchCount')
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    refreshSelectedLuConcern(context, payload) {
      if (
        context.state.selectedLuConcern &&
        context.state.selectedLuConcern.ID
      ) {
        context.dispatch(
          'loadSelectedLuConcern',
          context.state.selectedLuConcern.ID
        )
      }
    },
    loadSelectedLuConcern(context, payload) {
      if (
        context.state.selectedLuConcern &&
        context.state.selectedLuConcern.ID != payload
      ) {
        context.commit('selectedLuConcern', {})
      }
      return new Promise((resolve, reject) => {
        const url = 'LuConcern/' + payload
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('selectedLuConcern', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    clearLookupCacheAndReloadLuConcerns(context, payload) {
      caches.delete('apilookup-cache').finally(() => {
        context.dispatch('loadLuConcerns')
      })
    },
    updateLuConcern(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `LuConcern/${payload.ID}`
        context.commit('saving', true)
        Vue.prototype.$axios.put(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'concern updated' },
              { root: true }
            )
            //if you will always need to reload the list after an update
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuConcerns')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    createLuConcern(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `LuConcern`
        context.commit('saving', true)
        Vue.prototype.$axios.post(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'concern created' },
              { root: true }
            )
            //if you will always need to reload the list after an item is created
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuConcerns')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    saveLuConcern(context, payload) {
      return new Promise((resolve, reject) => {
        if (payload.ID > 0) {
          context.dispatch('updateLuConcern', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        } else {
          context.dispatch('createLuConcern', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        }
      })
    },
    deleteLuConcern(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `LuConcern/${payload.ID}`
        Vue.prototype.$axios.delete(url).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'concern deleted' },
              { root: true }
            )
            //if you will always need to reload the list after a delete
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuConcerns')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
  },
}

export default luConcern
